import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import * as React from 'react';

interface IDialogProps {
    title: string;
    children: React.ReactNode;
    open: boolean;
    onClose: () => void;
    actionLabel?: string;
    onAction?: () => void;
    showCancel?: boolean;
    showCloseButton?: boolean;
}

export const ModalDialog: React.FC<IDialogProps> = ({
    title,
    children,
    open,
    onClose,
    actionLabel,
    onAction,
    showCancel = false,
    showCloseButton = true,
}) => {
    return (
        <Dialog open={open} onClose={onClose} className="relative z-50 text-slate-900 dark:text-slate-200">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full justify-center p-4 items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="w-full sm:w-auto relative transform overflow-hidden rounded-lg bg-slate-50 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-slate-700 sm:max-w-4xl">
                        <div className="bg-slate-50 dark:bg-slate-700 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                            <div className="flex flex-col mt-3 sm:mt-0 sm:text-left text-sm">
                                <DialogTitle as="h1" className="font-semibold text-xl mb-4 flex justify-between">
                                    <div className="mr-4">{title}</div>
                                    {showCloseButton && (
                                        <button onClick={onClose} className="self-start">
                                            <XMarkIcon className="size-6" />
                                        </button>
                                    )}
                                </DialogTitle>
                                {children}
                                {(showCancel || (actionLabel && onAction)) && (
                                    <div className="mt-4 flex justify-end gap-4">
                                        {showCancel && (
                                            <button
                                                onClick={onClose}
                                                className="shadow-sm ring-1 ring-inset ring-gray-300 dark:shadow-none dark:ring-0 inline-flex items-center gap-2 rounded-md bg-white hover:bg-gray-50 dark:hover:bg-slate-400 text-gray-90 dark:bg-slate-600 py-1.5 px-3 text-sm/6 font-semibold dark:text-white data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                                                Cancel
                                            </button>
                                        )}
                                        {actionLabel && onAction && (
                                            <button
                                                onClick={onAction}
                                                className="inline-flex w-16 justify-center items-center gap-2 rounded-md bg-primary-400 py-1.5 px-3 text-sm/6 font-semibold text-white data-[hover]:bg-primary-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                                                {actionLabel}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};
